// extracted by mini-css-extract-plugin
export default {"content_wrapper":"BaseLayout_content_wrapper__avfHH","base_layout":"BaseLayout_base_layout__wg74B"};